import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { InfoBox, Button, LoadingCircle } from 'hosman-material';
import { updatePhotoPacks, updateStep } from '../../../../../../../../../reducers/SellerApp/photoMeetingsSlice';

const PackMax = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { photoPacks: { lightshop_fee, lightshop_pack_max, isSubmitting } } = useSelector((state) => state.sellerPhotoMeetings);
  const [isReady, setIsReady] = useState(false)
  const dispatch = useDispatch();

  useEffect(() => {
    // Avoid asking for payment infos if no price given from LS
    if (lightshop_fee) return setIsReady(true);
  
    const fetchData = async () => {
      try {
        const resultAction = await dispatch(
          updatePhotoPacks({ saleId: sale.id, params: { lightshop_pack_max: false } })
        );
  
        if (updatePhotoPacks.fulfilled.match(resultAction)) {
          dispatch(updateStep('PhotoMeeting'));
        }
      } catch (error) {
        console.error('Erreur lors de la mise à jour des packs photo :', error);
      }
    };
  
    fetchData();
  }, [lightshop_fee]);

  const handlePhotoMeeting = async (params) => {
    if (isSubmitting) return;

    if (!lightshop_pack_max && !params.lightshop_pack_max) return dispatch(updateStep('PhotoMeeting'));

    try {
      const resultAction = await dispatch(
        updatePhotoPacks({ saleId: sale.id, params: params })
      );

      if (updatePhotoPacks.fulfilled.match(resultAction)) {
        dispatch(updateStep('PhotoMeeting'));
      }
    } catch (error) {
      console.error('Erreur lors de la mise à jour des packs photo :', error);
    }
  }

  if (!isReady) return <LoadingCircle />

  return (
    <div className='flex flex-col gap-6 text-ih-indigo'>
      <p className='h2'>Nous vous proposons la prestation 2 en 1 : reportage photo et dossier de diagnostic technique (DDT - diagnostics obligatoires pour la vente)</p>

      <p className='font-semibold'>Elle sera réalisée par notre prestataire indépendant Lightshop, spécialiste des diagnostics et des reportages photos.</p>

      <InfoBox avatarSrc={sale.expert?.user?.profile_pic_url} bgColor='bg-ih-green-5' borderColor='border-ih-green-50'>
        <p>Cette prestation vous permet de gagner du temps : en regroupant le reportage photo et la réalisation des diagnostics obligatoires.</p>
      </InfoBox>

      <InfoBox>
        <p>Le prix pour vos diagnostics complets : {lightshop_fee} €.
        Le reportage photo est pris en charge à 100% par Hosman.</p>
      </InfoBox>

      <div className='flex justify-center gap-3'>
        <Button label='Réserver ma prestation' onClick={() => handlePhotoMeeting({ lightshop_pack_max: true })} isLoading={isSubmitting} />
      </div>

      <p className='text-sm font-semibold text-ih-indigo-50 underline text-center md:w-1/2 mx-auto cursor-pointer' onClick={() => handlePhotoMeeting({ lightshop_pack_max: false })}>Je préfère réaliser les diagnostics avec un prestataire de mon choix</p>
    </div>
  )
}

export default PackMax;
